import { organizationsApi } from '../api'
import { setOrganizationsList, setLoading } from '../store/organizations/slice'


export const getOrganizations = () => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const response = await organizationsApi.getList()
    dispatch(setOrganizationsList(response.data.data))
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}
